import { useEffect } from 'react'

import { addBreadcrumb } from '@sentry/react'
import { useQueryClient } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import { useAuthenticatedFirebaseUser } from './auth/useFirebaseUser'
import { router } from './router'

export const AppRouter = () => {
  const queryClient = useQueryClient()
  const auth = useAuthenticatedFirebaseUser()

  useEffect(() => {
    addBreadcrumb({ category: 'auth', message: 'AppRouter', data: { auth } })
  }, [queryClient, auth])

  return (
    <RouterProvider
      router={router}
      context={{
        queryClient,
        auth,
      }}
    />
  )
}
